<script setup lang="ts">
import useLocale from '../../composables/useLocale';

type Emits = {
  (e: 'click'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  color: string;
  title: string;
  active?: boolean;
};
defineProps<Props>();

const { t } = useLocale();
</script>

<template>
  <v-btn
    color="on-primary"
    variant="text"
    :ripple="false"
    icon
    :class="{ 'color-is-active': active }"
    :title="title"
    :aria-label="t(`book_player.label_annotation_color_${title}`)"
    :aria-pressed="active"
    @click="emit('click')"
  >
    <div class="ball" :class="{ active: active }"></div>
    <v-tooltip activator="parent" location="bottom" :text="t(`book_player.label_annotation_color_${title}`)" />
  </v-btn>
</template>

<style scoped lang="scss">
// v-btn has overflow:hidden by default which clips child outlines.
// .color-is-active (not :deep) matches the button root element itself via [data-v-x].
.color-is-active {
  overflow: visible !important;
}

.ball {
  width: 30px;
  height: 30px;
  background-color: v-bind(color);
  border-radius: 50%;
  transition: transform 0.12s ease;

  &:hover:not(.active) {
    transform: scale(1.1);
  }

  &.active {
    // --highlight-ring-color is set by each parent context (bar = on-inverse-surface, dialog = on-surface).
    // Falls back to on-inverse-surface for the bar/menu context.
    outline: 3px solid var(--highlight-ring-color, rgb(var(--v-theme-on-inverse-surface)));
    outline-offset: 2px;
  }
}
</style>
